import { useUserLookupStore } from '../store/use-user-lookup-store';
export const useMemberOf = (userId) => {
    return useUserLookupStore((s) => (userId ? s.allUsers[userId] : undefined));
};
//# sourceMappingURL=use-member-of.js.map